export async function Cached(key, fetcher, interval = 60000) {
    const k_value = `cache_${key}_value`;
    const k_time = `cache_${key}_time`;

    if (window[k_value] && window[k_time] && (Date.now() - window[k_time] < (interval * 1000))) {
        return window[k_value];
    }

    const value = await fetcher();
    window[k_value] = value;
    window[k_time] = Date.now();
    return value;
}

export function ClearCache(key) {
    const k_value = `cache_${key}_value`;
    const k_time = `cache_${key}_time`;
    delete window[k_value];
    delete window[k_time];
}

export function ClearAllCache() {
    for (const key of Object.keys(window)) {
        if (key.startsWith("cache_")) {
            delete window[key];
        }
    }
}
